import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { InlineSpinner } from './LoadingIndicator';

const UploadProgress = ({ isUploading, progress = 0, error = null, success = false }) => {
  if (!isUploading && !error && !success) return null;

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg border">
      <div className="flex items-center space-x-3">
        {isUploading && (
          <>
            <InlineSpinner className="text-blue-500 border-blue-500/30 border-t-blue-500" />
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-700">Uploading files...</div>
              <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                <div 
                  className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <div className="text-xs text-gray-500 mt-1">{progress}% complete</div>
            </div>
          </>
        )}
        
        {error && (
          <>
            <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-500" />
            <div className="text-sm text-red-700">
              <div className="font-medium">Upload failed</div>
              <div>{error}</div>
            </div>
          </>
        )}
        
        {success && (
          <>
            <FontAwesomeIcon icon={faCheck} className="text-green-500" />
            <div className="text-sm text-green-700 font-medium">Files uploaded successfully</div>
          </>
        )}
      </div>
    </div>
  );
};

export default UploadProgress;